import { safeFormatISODate } from '../../../util/datetime-fns';
import type { HotelOption, HotelRoom } from '../../types';

type VioHiddenInputValues = {
    label: string;
    placeId?: string;
    hotelId?: string;
    checkIn: string;
    checkOut: string;
    rooms: string;
};

const formatRoom = (room: HotelRoom): string =>
    room.children.length === 0 ? `${room.adults}` : `${room.adults}:${room.children.join(',')}`;

export const createVioParams = (
    destination: HotelOption,
    startDate: Date | undefined,
    endDate: Date | undefined,
    rooms: HotelRoom[],
): VioHiddenInputValues => ({
    label: 'HomepageClickTracking',
    ...(destination.type === 'hotel' ? { hotelId: destination.objectId } : { placeId: destination.objectId }),
    checkIn: safeFormatISODate(startDate) ?? '',
    checkOut: safeFormatISODate(endDate) ?? '',
    rooms: rooms.map(formatRoom).join('|'),
});
